<div class="custom-box1"  *ngIf="isDataAvailable()">
  <div class="col-xs-12 col-md-12 col-lg-12  tender-auction-section1  ">
    <ol class="breadcrumb" *ngIf="menuService.getSelectedMenu() as menuItem">
      <span cbicTranslate="menu.{{menuItem.menuName}}">
      </span>
      <!-- <span class="breadcrumb-item">
          <a routerLink="/{{menuItem.path}}" class="bredcrumb-trimmed-text" cbicTranslate="menu.{{menuItem.menuName}}"></a>
      </span> -->
    </ol>

    <div class="tender-auction-data" >
      <!-- <div class="col-12 float-start mt1 "> -->
      <!-- <div class="float-start"> -->
        <div class="row my-3">
        <div class="col-md-3 d-flex">
        <select (change)="ontableSizeChange($event)" class="form-select-sm show_entries">
          <option *ngFor="let size of tableSizes">
            {{size}}
          </option>
        </select>
      
      </div>

      <!-- </div> -->
      <div class="col-md-6">
        <!-- filter section here -->
      </div>
      <div class="col-md-3">
      <div class="float-end">
        <pagination-controls previousLabel="Prev" nextLabel="Next"
        (pageChange)="onTableDataChange((page = $event))"></pagination-controls>


      </div>
    </div>
  </div>
    <!-- </div> -->

     

<div *ngIf="usedLanguage === 'en'" class="table-responsive tender-auction-data " id="scrollonpage">
      <table class="table table-hover table-bordered table-striped shadow" >
        <thead class="table-light">
          <tr>
            <th>S.No.</th>
            <th>Last date of submission</th>
            <th>Brief Description</th>

          </tr>
        </thead>
        <tbody class="customizeHeight custom-scroll-bar">
          <tr scope="row"
            *ngFor="let product of tenderData | paginate :{itemsPerPage :tableSize,currentPage: page,totalItems:count};  let i=index;">
            <td>{{ (page - 1) * tableSize + i + 1 }}</td>
            <!-- <th scope="row">{{ (page - 1) * tableSize + i + 1 }}</th>    -->
            <td>{{ product.publishDt |date: 'dd-MMM-yyyy':'UTC'}}</td>
            <td>
            <span *ngFor="let tendersPdf of PdfDataList">
           
              <span
                *ngIf="product.id === tendersPdf.content?.id && tendersPdf.docTitleEn !== null && tendersPdf.filePathEn !== null">
                <a [routerLink]="" class="tble_desc" (click)="ViewPdf(tendersPdf.filePathEn)">
                  {{tendersPdf.docTitleEn}}<td><span
                      [ngClass]="tendersPdf.docType == 'pdf' ? 'pdf-icon' : 'xls-icon'"></span></td></a>
                   
               </span> 
            </span>
          </td>
          </tr>
          
        </tbody>
        
      </table>
    </div>

    <div *ngIf="usedLanguage === 'hi'" class="table-responsive  tender-table-section1" id="scrollonpage">
      <table class="table table-condensed table-hover table-bordered table-striped table-fixed shadow">
        <thead class="table-light">
          <tr>
            <th>क्र.सं.</th>
            <th>प्रस्तुत करने की अंतिम तिथि</th>
            <th>संक्षिप्त विवरण</th>

          </tr>
        </thead>
        <tbody>
          <tr scope="row"
            *ngFor="let product of tenderData | paginate :{itemsPerPage :tableSize,currentPage: page,totalItems:count};  let i=index;">
            <td>{{ (page - 1) * tableSize + i + 1 }}</td>
            <!-- <th scope="row">{{ (page - 1) * tableSize + i + 1 }}</th>    -->
            <td>{{ product.publishDt |date: 'dd-MMM-yyyy':'UTC'}}</td>
            <td>
            <span *ngFor="let tendersPdf of PdfDataList">
           
              <span
                *ngIf="product.id === tendersPdf.content?.id && tendersPdf.docTitleHi !== null && tendersPdf.filePathHi !== null">
                <a [routerLink]="" class="tble_desc" (click)="ViewPdf(tendersPdf.filePathHi)">
                  {{tendersPdf.docTitleHi}}<td><span
                      [ngClass]="tendersPdf.docType == 'pdf' ? 'pdf-icon' : 'xls-icon'"></span></td></a>
                   
               </span> 
               <span
                *ngIf="product.id === tendersPdf.content?.id && tendersPdf.docTitleHi ===null && tendersPdf.filePathHi === null">
                <a [routerLink]="" class="tble_desc" (click)="ViewPdf(tendersPdf.filePathEn)">
                  {{tendersPdf.docTitleEn}}<td><span
                      [ngClass]="tendersPdf.docType == 'pdf' ? 'pdf-icon' : 'xls-icon'"></span></td></a>
                   
               </span>

            </span>
          </td>
          </tr>
          
        </tbody>  
        
      </table>
    </div>

    <!---  <div>
        <pagination-controls previousLabel="Prev" nextLabel="Next"
        (pageChange)="onTableDataChange((page = $event))"></pagination-controls>


      </div>-->

    </div>



  </div>



</div>